export default "__VITE_ASSET__okjfTj15__"